export enum EditMode {
  CREATE,
  EDIT,
}

export type InquiryInfoValue = {
  channelName?: string;
  channelType?: string;
  closedReasonId?: string;
  equipSourceId?: string;
  id?: string;
  informationSourceId?: string;
  inquiryDate?: Date;
  inquiryNote?: string;
  inquirerRole?: string;
  patientAge?: number;
  readonly isClosed?: boolean;
  statusId?: string;
  targetTreatmentProgramName?: string;
  tellUsMore?: string;
};

export type PatientInfoValue = {
  chosenName?: string;
  dateOfBirth?: string; // Format is MM/DD/YYYY
  email?: string;
  firstName?: string;
  genderOnRecord?: string;
  hasGivenRecordingConsent?: boolean;
  id?: string;
  isPrimaryContact?: boolean;
  isInvalidEmail?: boolean;
  isInvalidPhone?: boolean;
  hasAppAccess?: boolean;
  languages?: string[];
  lastName?: string;
  phoneNumber?: string;
  pronounsOnRecord?: string[];
  state?: string;
  timezone?: string;
};

export type ContactInfoValue = {
  cellPhone?: string;
  chosenName?: string;
  contactExternalId?: string;
  email?: string;
  firstName?: string;
  isPrimaryContact?: boolean;
  isInvalidEmail?: boolean;
  isInvalidCellPhone?: boolean;
  isSupport?: boolean;
  languages?: string[];
  lastName?: string;
  pronouns?: string[];
  relationToPatient?: string;
  timezone?: string;
};

export type CoveragePriorityValue = 1 | 2 | 3;

export type CoverageInfoValue = {
  alternativeId?: string;
  customPayorName?: string;
  coverageExternalId?: string;
  coveragePriority?: CoveragePriorityValue;
  endDate?: string; // Format is MM/DD/YYYY
  groupId?: string;
  isActive?: boolean;
  patientRelationToSubscriber?: string;
  payor?: string;
  providerServicesPhoneNumber?: string;
  stateCode?: string;
  startDate?: string; // Format is MM/DD/YYYY
  subscriberDateOfBirth?: string;
  subscriberFirstName?: string;
  subscriberId?: string;
  subscriberLastName?: string;
};

export type ReferralInfoValue = {
  addressLine1?: string;
  addressLine2?: string;
  name?: string;
  city?: string;
  contactExternalId?: string;
  email?: string;
  faxNumber?: string;
  firstName?: string;
  isOngoingProvider?: boolean;
  isPrimaryContact?: boolean;
  isReferringProvider?: boolean;
  isInvalidEmail?: boolean;
  isInvalidOfficePhone?: boolean;
  lastName?: string;
  latitude?: number;
  longitude?: number;
  officeExtension?: string;
  officePhone?: string;
  prefix?: string;
  referrerType?: string;
  relationToPatient?: string;
  state?: string;
  timezone?: string;
  zipCode?: string;
};

export type ActivityWithName = 'Carer' | 'Patient' | 'Provider';

export type NoteInfoValue = {
  content?: string;
  isQualifyingCall?: boolean;
  activityWithName?: ActivityWithName;
};

export type InquiryValues = {
  contacts: ContactInfoValue[];
  // TODO Convert to list of coverages: https://teamequip.atlassian.net/browse/PT-13
  coverages: CoverageInfoValue;
  info: InquiryInfoValue;
  note: NoteInfoValue;
  patient: PatientInfoValue;
  referral: ReferralInfoValue;
};

export type AssignedProvider = {
  externalId: string;
  firstName: string;
  lastName: string;
  providerType: string;
  displayFirstName?: string;
  displayLastName?: string;
  avatar?: AvatarDetails;
};

export const CLASS_MISSING_REQUIRED = 'inquiry-missing-required-field';

export interface DropdownBaseProps {
  id: string;
  isDisabled?: boolean;
  isInvalid?: boolean;
  isRequired?: boolean;
  onSelect: (val: string) => void;
  placeholder?: string;
  value: string;
}

export interface DropdownMultiSelectProps {
  id: string;
  isDisabled?: boolean;
  isInvalid?: boolean;
  isRequired?: boolean;
  placeholder?: string;
  values: string[];
  onSelectValues: (values: string[]) => void;
}
